// fetch agreements from TermsCondition collections
// do checkbox validation
// pass agreement id, user id, account id, email id, company name, ip address
// backend => userAgreement collection entry + update Accepted flag in user collection
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { setLoggedInUser } from 'store/actions/termsAndConditionsActions';
import { withStyles } from '@material-ui/core';
import AgreementTermsStyle from './AgreementTermsStyle';
import Modal from '@material-ui/core/Modal';
import AgreementTerms from './AgreementTerms';
import Auxiliary from 'hoc/Auxiliary';
import CustomHeader from 'components/CustomHeader/CustomHeader';

const AgreementTermsMapping = (props) => {
    useEffect(() => {
        if (props.loggedInUserTerms.is_agreed) {
            props.history.push('/connections');
        }
    }, [props.loggedInUserTerms.is_agreed]);
    return (
        <Auxiliary>
            <CustomHeader title="TERMS OF USE" />
            <Modal open={!props.loggedInUserTerms.is_agreed && props.loggedInUserTCPermission}>
                <AgreementTerms />
            </Modal>
        </Auxiliary>
    );
};

const mapStateToProps = (state) => ({
    loggedInUserTerms: state.termsAndConditions.loggedInUserTerms,
    loggedInUserTCPermission: state.termsAndConditions.loggedInUserTCPermission
});

export default connect(mapStateToProps, { setLoggedInUser })(
    withStyles(AgreementTermsStyle)(AgreementTermsMapping)
);
